// The one agent model picker (phase M, M4-2): "Workspace default (currently X)"
// or a pinned chat model. Reads and writes only flow_config.llm.mode (+ the
// pinned target) — the backend's one writer keeps the provider/model columns
// in step. Used by Overview, the Graph drawer's LLM node and the
// platform-managed agent view.
import { useMemo } from "react";
import EditableField from "./EditableField";
import { useAvailableModels } from "../../../../hooks/useAvailableModels";
import { useWorkspaceDefault } from "../../../../hooks/useWorkspaceDefault";
import {
  choiceValue, decodeChoice, modelChoiceOptions, modelLabel, modelPatch, modelSettingOf,
} from "../../../../utils/agentModel";

export default function AgentModelField({ agent, saveAgent, readOnly = false, label = "Model" }) {
  const { models, llmConfigured } = useAvailableModels();
  const workspaceDefault = useWorkspaceDefault(agent?.id);
  const setting = useMemo(
    () => modelSettingOf({ provider: agent?.provider, model: agent?.model, flow_config: agent?.flow_config }),
    [agent?.provider, agent?.model, agent?.flow_config],
  );
  const options = useMemo(
    () => modelChoiceOptions(models, workspaceDefault, setting),
    [models, workspaceDefault, setting],
  );
  return (
    <EditableField
      label={label}
      variant="select"
      value={choiceValue(setting)}
      renderDisplay={() => modelLabel(setting, workspaceDefault)}
      options={options}
      onSave={async (v) => saveAgent(modelPatch(decodeChoice(v)))}
      readOnly={readOnly}
      hint={llmConfigured === false ? "No provider configured — set keys in Admin → API Keys" : undefined}
    />
  );
}
